<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row">
            <!-- Items per page -->
            <div class="col-md-6">
              <div class="row">
                <!-- Items per page -->
                <div class="col-sm-12 col-md-8">
                  <div class="row align-items-center">
                    <div class="col-3 m-0">Mostrar&nbsp;</div>
                    <div class="col-3 m-0 p-0">
                      <b-form-select v-model="perPage" size="sm" :options="[20, 50, 100]"></b-form-select>
                    </div>
                    <div class="col-3 m-0 p-0">&nbsp;por página</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Upload File -->
            <div class="col-md-6 d-flex justify-content-end">
              <div class="row align-items-center">
                <button class="btn btn-sm btn-primary mr-2" @click="triggerFileInput" :disabled="!canImportChargebacks">
                  <i class="fa fa-upload" aria-hidden="true"></i> Importar Arquivo
                </button>
                <!-- Input de arquivo -->
                <input type="file" ref="fileInput" @change="handleFileUpload" accept=".csv" style="display: none;" />
              </div>
            </div>
          </div>
        </div>
        <!-- Search -->

        <b-col cols="12" class="d-flex flex-wrap justify-content-between py-1">
          <!-- Select e date-picker do filtro por data -->
          <div
            class="d-flex justify-content-start align-items-center text-md-left b-form-input mt-1 col-lg-4 col-md-12">
            <label class="d-inline-flex align-items-center">
              <b-form-select v-model="filterType" :options="filterOptions" class="form-control  ml-2">
              </b-form-select>
            </label>
            <label class="d-inline-flex align-items-center mt-1">
              <DateFilter />
            </label>
          </div>
          <!-- Outros filtros -->
          <div
            class="d-flex justify-content-end align-items-center text-md-right b-form-input col-12 col-md-auto  mt-1">
            <label class="d-inline-flex align-items-center">
              <b-form-input v-model="sale_id" type="search" placeholder="ID da Venda..."
                class="form-control"></b-form-input>
            </label>
            <label class="d-inline-flex align-items-center">
              <b-form-input v-model="transaction_id" type="search" placeholder="ID Transação..."
                class="form-control  ml-2"></b-form-input>
            </label>
            <label class="d-inline-flex align-items-center">
              <b-form-select v-model="status" :options="statusOptions" class="form-control  ml-2">
              </b-form-select>
            </label>
            <div class="d-inline-flex align-self-start ml-2">
              <b-button variant="light" class="text-success" @click="onSearch" title="Buscar">
                <i class="fas fa-search"></i>
              </b-button>

              <!-- Limpar filtros -->
              <b-button variant="light" @click="clearFilters" class="ml-2" title="Apagar filtros">
                <i class="fas fa-eraser"></i>
              </b-button>

            </div>
          </div>
        </b-col>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead class="thead-light">
          <tr>
            <th v-for="(column, index) in columns" :key="index" class="text-left">
              <span @click="toggleSort(column)" class="cursor-pointer">
                <span v-if="sortableColumns.includes(column)" v-html="getSortIcon(column)" class="toogleSort"></span>
                {{ column }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="sortedChargebacks.length === 0">
            <td :colspan="columns.length" class="text-center">Nenhum item encontrado</td>
          </tr>
          <tr v-for="(row, rowIndex) in sortedChargebacks" :key="rowIndex">
            <td>{{ row.sale_id }}</td>
            <td :class="getStatusClass(row.status)">
              {{ translatedStatus(row.status) }}
            </td>
            <td>{{ formattedDate(row.transaction_at) }}</td>
            <td>{{ formattedDate(row.chargedback_at) }}</td>
            <td>{{ row.transaction_id }}</td>
            <td>{{ formattedAmount(row.amount) }}</td>
            <td>
              <!-- Botão Atualizar Status -->
              <button class="btn btn-sm btn-light mr-2" @click="openUpdateModal(row)" title="Atualizar Status"
                :disabled="!canChangeStatus || ['WE_WON','WE_LOST'].includes(row.status)">
                <i class="fas fa-edit"></i>
              </button>
              <!-- Botão Visualizar Histórico -->
              <button v-if="row.audit.length" class="btn btn-sm btn-light text-info" @click="openHistoryModal(row)"
                title="Visualizar histórico">
                <i class="fas fa-history"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal de edição -->
    <b-modal v-model="showModal" title="Confirmar Atualização" hide-footer>
      <div class="d-block text-center">
        <p>Selecione o novo status para o item:</p>
        <!-- Select de status -->
        <b-form-select v-model="selectedStatus" :options="statusOptions"></b-form-select>
        <!-- Campo para inserir a razão -->
        <b-form-group label="Motivo da atualização:" class="mt-3">
          <b-form-textarea v-model="reason" placeholder="Digite o motivo da atualização..." required maxlength="500"
            rows="3">
          </b-form-textarea>
          <small class="text-muted">{{ reason.length }}/500</small>
        </b-form-group>
      </div>

      <!-- Botões modal -->
      <div class="d-flex justify-content-center mt-3">
        <b-button variant="secondary" @click="showModal = false">Cancelar</b-button>
        <b-button variant="primary" class="ml-2" @click="updateStatus" :disabled="!reason.trim()">Confirmar</b-button>
      </div>
    </b-modal>

    <!-- Modal para visualizar histórico -->
    <b-modal v-model="showHistoryModal" title="Histórico de Alterações" hide-footer size="xl">
      <div class="table-responsive" style="max-height: 70vh; overflow-y: auto;">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Data de Alteração</th>
              <th>Status Antigo</th>
              <th>Novo Status</th>
              <th>Motivo</th>
              <th>Responsável</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(entry, index) in sortedHistory" :key="index">
              <td>{{ formattedDate(entry.created_at) }}</td>
              <td :class="getStatusClass(JSON.parse(entry.original).status)">{{
                translatedStatus(JSON.parse(entry.original).status) }}</td>
              <td :class="getStatusClass(JSON.parse(entry.updated).status)">{{
                translatedStatus(JSON.parse(entry.updated).status) }}</td>
              <td>{{ entry.reason }}</td>
              <td>{{ entry.user_id }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Botão para fechar -->
      <div class="d-flex justify-content-end mt-3">
        <b-button variant="secondary" @click="showHistoryModal = false">Fechar</b-button>
      </div>
    </b-modal>


    <!-- Loading -->
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="chargebacks.length > 0" class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
              @change="changeCurrentPage"></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/src/components/page-header.vue';
import DateRangePicker from 'vue2-daterange-picker'
import Money from '@src/mixins/money'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import DateFilter from './components/DateFilter.vue';
import { AccessLevel } from '@views/configurations/enums/accessLevel'

export default {
  components: { PageHeader, DateRangePicker, DateFilter },
  mixins: [Money],
  data() {
    return {
      status: null,
      title: 'Chargebacks',
      items: [
        { text: 'Início', href: '/' },
        { text: 'Chargeback', active: true }
      ],
      pageOptions: [10, 20, 50, 100, 500],
      filters: {},
      showModal: false,
      selectedStatus: '',
      selectedItem: null,
      statusOptions: [
        { value: null, text: 'Status...' },
        { value: 'NOT_BEING_WORKED', text: 'Não foi trabalhado' },
        { value: 'IS_BEING_WORKED', text: 'Está sendo trabalhado' },
        { value: 'WE_WON', text: 'Vencemos' },
        { value: 'WE_LOST', text: 'Perdemos' },
      ],
      sale_id: null,
      transaction_id: null,
      status: null,
      currentPage: 1,
      sortColumn: null,
      sortDirection: null,
      sortableColumns: ["Data da Transação", "Data do Chargeback"],
      reason: '',
      showHistoryModal: false,
      selectedHistory: [],
      filterOptions: [
        { value: null, text: 'Filtro por Data...' },
        { text: 'Data da Transação', value: 'transaction_at' },
        { text: 'Data do Chargeback', value: 'chargeback_at' }
      ],
      filterType: null,
    }
  },

  mounted() {
    this.fetchChargebacks();
  },
  computed: {
    ...mapGetters({
      chargebacks: 'getChargebacks',
      loading: 'getChargebackLoading',
      getChargebackCurrentPage: 'getChargebackCurrentPage',
      totalRows: 'getChargebackTotalRows',
      getFilterDate: 'getFilterDate'

    }),
    columns() {
      return ["ID da Venda", "Status", "Data da Transação", "Data do Chargeback", "ID da Transação", "Valor da Transação", "Ações"];
    },
    perPage: {
      get() {
        return this.$store.getters.getChargebackPerPage
      },
      set(value) {
        this.$store.dispatch('updateChargebacksPerPage', value)
      }
    },
    translatedStatus() {
      return (status) => {
        const option = this.statusOptions.find(item => item.value === status);
        return option ? option.text : 'Desconhecido'; // Retorna "Desconhecido" caso o status não seja encontrado
      };
    },
    formattedDate() {
      return (dateString) => {
        if (!dateString) return 'Data inválida';

        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      };
    },
    formattedAmount() {
      return (value) => {
        if (!value) return 'R$ 0,00';

        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2
        }).format(value);
      };
    },
    sortedChargebacks() {
      if (!this.sortColumn || !this.sortDirection) {
        return this.chargebacks;
      }

      return [...this.chargebacks].sort((a, b) => {
        const field =
          this.sortColumn === "Data da Transação"
            ? "transaction_at"
            : "chargedback_at";

        const dateA = new Date(a[field]);
        const dateB = new Date(b[field]);

        return this.sortDirection === "asc"
          ? dateA - dateB
          : dateB - dateA;
      });
    },
    sortedHistory() {
      return [...this.selectedHistory].sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
    },
    canChangeStatus() {
      return this.$canAction('chargeback_change_status_button', [AccessLevel.EDITOR])
    },
    canImportChargebacks() {
      return this.$canAction('chargebacks_import_button', [AccessLevel.EDITOR])
    },
  },
  watch: {
    perPage() {
      this.fetchChargebacks()
    },
    filter() {
      this.debounce()
    },
    filterType(value) {
      const invalidDate = (this.getFilterDate.startDate || this.getFilterDate.endDate) == 'Invalid date';
      if(! invalidDate){
        this.$store.dispatch('updateChargebacksCurrentPage', 1)
        this.$store.dispatch('updateTypeFilterDate', value)
        if (Object.keys(this.getFilterDate).length != 0 ) {
          this.$store.dispatch('fetchChargebacks')
        }
      }
    },
  },
  methods: {
    fetchChargebacks() {
      this.$store.dispatch('fetchChargebacks')
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    changeCurrentPage(currentPage) {      
      this.$store.dispatch('updateChargebacksCurrentPage', currentPage)
      this.fetchChargebacks()
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.$store.dispatch('uploadFile', formData)
        .then(() => {
          this.$bvToast.toast('Upload feito com sucesso!', {
            variant: 'success',
            title: 'Upload de Arquivo',
            autoHideDelay: 5000,
          })
        })
      return
    },
    openUpdateModal(row) {
      this.selectedItem = row;
      this.selectedStatus = row.status;
      this.showModal = true;
    },
    updateStatus() {
      if (this.selectedItem) {
        const data = {
          id: this.selectedItem.id,
          status: this.selectedStatus,
          reason: this.reason
        }
        this.$store.dispatch('updateStatus', data)
          .then(() => this.reason = '')
      }
      this.showModal = false;
    },
    getStatusClass(status) {
      switch (status) {
        case 'NOT_BEING_WORKED':
          return 'text-muted';
        case 'WE_WON':
          return 'text-success';
        case 'WE_LOST':
          return 'text-danger';
        case 'IS_BEING_WORKED':
          return 'text-info';
        default:
          return 'text-muted';
      }
    },
    onSearch() {
      this.currentPage = 1
      this.$store.dispatch('updateChargebacksCurrentPage', 1)      
      const data = {
        status: this.status,
        sale_id: this.sale_id,
        transaction_id: this.transaction_id
      }
      this.$store.dispatch('updateChargebacksFilter', data)
      this.debounce()
    },
    debounce: _.debounce(function () {
      this.fetchChargebacks()
    }, 500),
    toggleSort(column) {
      if (!this.sortableColumns.includes(column)) return;

      if (this.sortColumn === column) {
        if (this.sortDirection === "asc") {
          this.sortDirection = "desc";
        } else if (this.sortDirection === "desc") {
          this.sortColumn = null;
          this.sortDirection = null;
        } else {
          this.sortDirection = "asc";
        }
      } else {
        this.sortColumn = column;
        this.sortDirection = "asc";
      }
    },
    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return '<i class="fas fa-arrows-alt-v"></i>';
      }
      return this.sortDirection === 'asc'
        ? '<i class="fas fa-arrow-up"></i>'
        : '<i class="fas fa-arrow-down"></i>';
    },
    openHistoryModal(row) {
      console.log(row);

      this.selectedHistory = row.audit || [];
      this.showHistoryModal = true;
    },
    clearFilters() {
      this.$store.dispatch('updateChargebacksFilter', '')
      this.$store.dispatch('updateFilterDate', {})
      this.$store.dispatch('updateTypeFilterDate', null)
      this.$store.dispatch('fetchChargebacks')
      this.$store.dispatch('updateFilterDate', {})
      this.$store.dispatch('updateNoFilters', true)
      this.filterType = null
      this.status = null
      this.sale_id = null
      this.transaction_id = null
    }
  },


}
</script>

<style scoped>
.custom-width {
  width: 18px;
}

.cursor-pointer {
  cursor: pointer;
}

.toogleSort {
  font-size: 10px;
}

.date-range-picker,
.b-form-input {
  height: 38px;
  /* ajuste conforme necessário */
}
</style>
